import { render, staticRenderFns } from "./ApplyTicketNoteTemplateModal.vue?vue&type=template&id=32ed20fc&scoped=true&"
import script from "./ApplyTicketNoteTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ApplyTicketNoteTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed20fc",
  null
  
)

export default component.exports